import React from 'react';
import { Link } from 'react-router-dom';
import { PRICING } from '../../data.js';
import './Passes.css';

const FLORIUM_URL = "https://florium.studio/flourish/embed";

export default function Passes() {
  return (
    <div className="passes-page">
      <section className="passes__hero">
        <p className="section-label">Passes & pricing</p>
        <h1 className="section-heading">Simple, flexible options</h1>
        <p className="passes__hero-sub">
          Whether you're dropping in for the first time or committing to a regular practice,
          we have an option that works for you.
        </p>
      </section>

           <section className="passes__grid-section">
        <div className="passes__grid">

          <div className="pass-detail-card">
            <p className="pass-detail-card__label">{PRICING.dropin.label}</p>
            <p className="pass-detail-card__price">${PRICING.dropin.price}</p>
            <p className="pass-detail-card__note">{PRICING.dropin.note}</p>
            <p className="pass-detail-card__detail">{PRICING.dropin.detail}</p>
            <a href={`${FLORIUM_URL}?openPass=${PRICING.dropin.floriumParam}`} className="pass-detail-card__btn">
              Buy now
            </a>
          </div>

          <div className="pass-detail-card pass-detail-card--featured">
            <div className="pass-detail-card__badge-row">
              <span className="pass-detail-card__badge">{PRICING.committed.badge}</span>
            </div>
            <p className="pass-detail-card__label">{PRICING.committed.label}</p>
            <p className="pass-detail-card__price">${PRICING.committed.price}<span>/mo</span></p>
            <p className="pass-detail-card__note">{PRICING.committed.note}</p>
            <p className="pass-detail-card__detail">{PRICING.committed.detail}</p>
            <a href={`${FLORIUM_URL}?openPass=${PRICING.committed.floriumParam}`} className="pass-detail-card__btn">
              Buy now
            </a>
          </div>

          <div className="pass-detail-card">
            <p className="pass-detail-card__label">{PRICING.pass4.label}</p>
            <p className="pass-detail-card__price">${PRICING.pass4.price}</p>
            <p className="pass-detail-card__note">{PRICING.pass4.note}</p>
            <p className="pass-detail-card__detail">{PRICING.pass4.detail}</p>
            <a href={`${FLORIUM_URL}?openPass=${PRICING.pass4.floriumParam}`} className="pass-detail-card__btn">
              Buy now
            </a>
          </div>

          <div className="pass-detail-card">
            <p className="pass-detail-card__label">{PRICING.monthly.label}</p>
            <p className="pass-detail-card__price">${PRICING.monthly.price}<span>/mo</span></p>
            <p className="pass-detail-card__note">{PRICING.monthly.note}</p>
            <p className="pass-detail-card__detail">{PRICING.monthly.detail}</p>
            <a href={`${FLORIUM_URL}?openPass=${PRICING.monthly.floriumParam}`} className="pass-detail-card__btn">
              Buy now
            </a>
          </div>

          <div className="pass-detail-card">
            <p className="pass-detail-card__label">{PRICING.pass8.label}</p>
            <p className="pass-detail-card__price">${PRICING.pass8.price}</p>
            <p className="pass-detail-card__note">{PRICING.pass8.note}</p>
            <p className="pass-detail-card__detail">{PRICING.pass8.detail}</p>
            <a href={`${FLORIUM_URL}?openPass=${PRICING.pass8.floriumParam}`} className="pass-detail-card__btn">
              Buy now
            </a>
          </div>

        </div>
      </section>

      <section className="passes__faq">
        <p className="section-label">Good to know</p>
        <h2 className="section-heading">How it works</h2>
        <div className="passes__faq-grid">
          <div className="passes__faq-item">
            <h3>Booking</h3>
            <p>All classes must be booked in advance online. Spaces are limited — book early to avoid disappointment.</p>
          </div>
          <div className="passes__faq-item">
            <h3>Cancellations</h3>
            <p>Cancel up to 1 hour before class to keep your credit. Late cancellations and no-shows forfeit the class.</p>
          </div>
          <div className="passes__faq-item">
            <h3>New students</h3>
            <p>Not sure where to start? Drop in to any beginner or all-levels class. Our teachers will make sure you feel at home.</p>
          </div>
          <div className="passes__faq-item">
            <h3>Memberships</h3>
            <p>Monthly memberships are billed automatically and <u>require a commitment of at least 3 months</u>. Cancelling within the first 3 months carries a $250 cancellation fee; after that, cancel anytime with 15 days' written notice. You can put your membership on hold for up to 2 weeks in each 3-month term by emailing the studio. The full terms are in the membership agreement you sign when you join.</p>
          </div>
        </div>
      </section>

      <section className="passes__cta">
        <h2 className="passes__cta-heading">Ready to start?</h2>
        <p className="passes__cta-sub">Book your first class today — no experience necessary.</p>
        <Link to="/book" className="btn-coral-inv">Book a class</Link>
      </section>
    </div>
  );
}
